import { render } from "./BacktestPeriod.vue?vue&type=template&id=32659eaa&scoped=true&ts=true"
import script from "./BacktestPeriod.vue?vue&type=script&lang=ts"
export * from "./BacktestPeriod.vue?vue&type=script&lang=ts"

import "./BacktestPeriod.vue?vue&type=style&index=0&id=32659eaa&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32659eaa"]])

export default __exports__